export default {
  UPDATE_QUERY (state, payload) {
    state.query = payload
  },
  UPDATE_SORT (state, payload) {
    state.sort = payload
  },
  UPDATE_SUBJECT (state, payload) {
    state.subject = payload
  },
  UPDATE_SEMESTER (state, payload) {
    state.semester = payload
  },
  UPDATE_SELECTED_SEMESTERS (state, payload) {
    state.selectedSemesters = payload
  },
  UPDATE_DIVISION (state, payload) {
    state.division = payload
  },
  UPDATE_INSTRUCTOR (state, payload) {
    state.instructor = payload
  },
  UPDATE_MAJOR (state, payload) {
    state.major = payload
  },
  UPDATE_UNIT (state, payload) {
    state.unit = payload
  },
  UPDATE_QR (state, payload) {
    state.qr = payload
  },
  UPDATE_KEYWORDS (state, payload) {
    state.keywords = payload
  },
  UPDATE_FIRSTYEAR (state, payload) {
    state.firstyear = payload
  },
  UPDATE_MONDAY (state, payload) {
    state.monday = payload
  },
  UPDATE_TUESDAY (state, payload) {
    state.tuesday = payload
  },
  UPDATE_WEDNESDAY (state, payload) {
    state.wednesday = payload
  },
  UPDATE_THURSDAY (state, payload) {
    state.thursday = payload
  },
  UPDATE_FRIDAY (state, payload) {
    state.friday = payload
  },
  UPDATE_CLASS_TIME_FROM (state, payload) {
    state.classTimeFrom = payload
  },
  UPDATE_CLASS_TIME_TO (state, payload) {
    state.classTimeTo = payload
  },
  UPDATE_TERMS (state, payload) {
    state.terms = payload
  },
  UPDATE_DEPARTMENT (state, payload) {
    state.department = payload
  },
  UPDATE_TIMESTAMP (state, payload) {
    state.lastUpdatedTime = payload
  },
  UPDATE_CATALOG_TIMESTAMP (state, payload) {
    state.catalogSearchTimeStamp = payload
  },
  UPDATE_FACETS (state, payload) {
    state.facets = payload
  },
  UPDATE_RESULTS (state, payload) {
    state.results = payload
  },
  UPDATE_OTHER_RESULTS (state, payload) {
    state.otherEntityResults = payload
  },
  UPDATE_TOTAL (state, payload) {
    state.total = payload
  },
  UPDATE_CATALOG_FACETS (state, payload) {
    state.catalogFacets = payload
  },
  UPDATE_CATALOG_RESULTS (state, payload) {
    state.catalogResults = payload
  },
  UPDATE_CATALOG_TOTAL (state, payload) {
    state.catalogTotal = payload
  },
  UPDATE_FROM (state, payload) {
    state.from = payload
  },
  UPDATE_PAGE_NUMBER (state, payload) {
    state.pageNumber = payload
  },
  UPDATE_SIZE (state, payload) {
    state.size = payload
  },
  UPDATE_COURSE_FLAGS (state, payload) {
    state.selectedCourseFlags = payload
  },
  UPDATE_COURSE_BLOCK (state, payload) {
    state.block = payload
  },
  UPDATE_COURSE_LEVEL (state, payload) {
    state.level = payload
  },
  UPDATE_TERM_CODE (state, payload) {
    state.termCode = payload
  },
  UPDATE_PLANNING_TERM (state, payload) {
    state.planningTermCode = payload
  },
  UPDATE_SELECTED_STREAM (state, payload) {
    state.selectedStreamUuid = payload
  },
  UPDATE_COURSE_SEARCH_FLAGS (state, payload) {
    state.courseSearchFlags = payload
  },
  UPDATE_COURSE_YEAR (state, payload) {
    state.academicYear = payload
  },
  UPDATE_CATALOG_SEARCH_FLAGS (state, payload) {
    state.catalogSearchFlags = payload
  },
  UPDATE_PUBLIC_LIBRARY_LIST (state, payload) {
    state.publicLibraryList = payload
  },
  UPDATE_PRIVATE_LIBRARY_LIST (state, payload) {
    state.privateLibraryList = payload
  },
  UPDATE_SEMESTER_MAP (state, payload) {
    state.semesterMap = payload
  },
  UPDATE_SEMESTER_CODE_MAP (state, payload) {
    state.semesterCodeMap = payload
  },
  SHOW_CATALOG_DROP_DOWN (state) {
    state.showCatalogSearchDropDown = true
  },
  HIDE_CATALOG_DROP_DOWN (state) {
    state.showCatalogSearchDropDown = false
  },
  TOGGLE_CATALOG_DROP_DOWN (state) {
    state.showCatalogSearchDropDown = !state.showCatalogSearchDropDown
  },
  UPDATE_SINGLE_FACET (state, payload) {
    let newFacet = payload.facet
    let facetToUpdate = state.facets[payload.facetName]
    facetToUpdate.forEach((facet) => {
      if (facet.term === newFacet.term) {
        facet.isSelected = payload.isSelected
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/advancedSearch/vuex/mutations.js